import { createContext, useContext } from 'react';

export const SelectPageContext = createContext(false);

export const useSelectPageContext = () => {
  return useContext(SelectPageContext);
};
